export const env = {
  // baseUrl: 'http://localhost:8069/api/covidalif/v0/',         // local
  // imgUrl: 'http://localhost:8069/api/covidalif/v0/images/',    // local
  // baseUrl: 'http://192.168.15.51/api/salom/v0/',       // dev
  // imgUrl: 'http://192.168.15.51/api/salom/v0/images/',  // dev
  imgUrl: 'https://covid.alif.tj/api/covidalif/v0/images/', // prod
  // baseUrl: 'https://covid.alif.tj/api/covidalif/v0/', // prod
  baseUrl: 'https://muhlat.alif.tj/api/covidalif/v0/', // prod
};
